import { Code, Group, Text } from "@mantine/core";
import RequirementLevelBadge from "./RequirementLevelBadge";

export default function TypeTooltip({ attrib }) {
  if (attrib.type == "Undefined")
    return (
      <Text fz="sm" c="dimmed">
        This attribute is invalid / unknown.
      </Text>
    );

  return (
    <div>
      <Group justify="space-between">
        <Text fz="sm" fw={600}>
          <Code>{attrib.hierarchyCode || "root"}</Code> {attrib.code}
        </Text>
        <RequirementLevelBadge my="xs" attrib={attrib} />
      </Group>

      <Text fz="sm">{attrib.description ?? ""}</Text>

      <Text mt="xs" fz="xs" c="dimmed" tt="uppercase" fw={500}>
        Type
      </Text>
      <Text fz="sm">{attrib.type}</Text>
      {attrib.possibleValues?.map((p) => (
        <Text key={p} fz="sm" c="dimmed">
          {p}
        </Text>
      ))}
      {attrib.roles?.length > 0 && (
        <Text mt="xs" fz="xs" c="dimmed" tt="uppercase" fw={500}>
          Roles
        </Text>
      )}
      {attrib.roles?.map((role) => (
        <Text key={role.type} fz="sm">
          {role.type}
        </Text>
      ))}
      {attrib.typeParameters && (
        <Text mt="xs" fz="xs" c="dimmed" tt="uppercase" fw={500}>
          Type Parameters
        </Text>
      )}
      {attrib.typeParameters?.map((param) => (
        <Text key={param.name} fz="sm">
          {param.name}: {param.value}
        </Text>
      ))}
      {attrib.variant && <Text>variant-defining</Text>}
      <Text mt="xs" fz="xs" c="dimmed" tt="uppercase" fw={500}>
        Metadata
      </Text>
      <Text fz="xs" c="dimmed">
        {attrib.id}
        <br />
        {attrib.lastFetched}
        <br />
        {attrib.idCreated}
      </Text>
    </div>
  );
}
